export default "__VITE_ASSET__54$$s0ow__"